import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { cancelBooking } from "../../../../redux/reducers/HotelPortalReducer";
import { Button, Tooltip, TextField, Grid } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import cloneDeep from "lodash/cloneDeep";

interface ICancelationProps {
  UItype: "text" | "button";
  rowParams: any;
  stateChanger?: (hideButton: string) => void;
}

export default function Cancelation(props: ICancelationProps): JSX.Element {
  const dispatch = useDispatch();
  const { UItype, rowParams, stateChanger } = props;
  const [cancelationCode, setCancelationCode] = useState<string>(rowParams.cancelationCode);
  const [showingTextField, setShowingTextField] = useState<boolean>(false);
  const hotelBookings: any = useSelector((state: IRootState) => state.hotelBookings.hotelBookings);
  const fetchingThunk = useSelector((state: IRootState) => state.hotelBookings.fetchingThunk);

  //Handlers
  const handleCancelation = (code: string, temp_id: string, hotelId: string): void => {
    const bookingDetail = hotelBookings.find((booking: any) => {
      return booking.temp_id === temp_id;
    });

    if (bookingDetail) {
      const canceledBooking = cloneDeep(bookingDetail);
      canceledBooking.cancelationCode = code;
      canceledBooking.isCanceled = true;
      delete canceledBooking.id;
      dispatch(
        cancelBooking({
          booking: canceledBooking,
          hotelIDs: [hotelId],
        })
      );
    }
  };
  const handleCodeChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    setCancelationCode(event.target.value);
  };
  const toggleCancelOverlay = (action: string): void => {
    setShowingTextField(!showingTextField);
    if (stateChanger) {
      if (action === "show") {
        stateChanger("Cancelation");
      } else {
        stateChanger("");
      }
    }
  };
  return (
    <>
      {!showingTextField && (
        <>
          {UItype === "button" && (
            <Tooltip title="Cancel this booking with a cancelation code">
              <>
                <Button
                  disabled={
                    (rowParams.statusName !== "noChanges" && rowParams.statusName !== "removals") || fetchingThunk
                  }
                  sx={{ color: "white" }}
                  color="error"
                  onClick={() => toggleCancelOverlay("show")}
                >
                  <DeleteForeverIcon sx={{ fontSize: "14px" }} />
                </Button>
              </>
            </Tooltip>
          )}
          {UItype === "text" && (
            <Grid container>
              <Grid
                item
                sx={{ width: "calc(100% - 30px)", whiteSpace: "nowrap", textOverflow: "ellipsis", overflowX: "hidden" }}
              >
                {cancelationCode}
              </Grid>
              {(cancelationCode || rowParams.statusName.toLowerCase() === "canceled") && (
                <Grid item sx={{ cursor: "pointer" }} onClick={() => toggleCancelOverlay("show")}>
                  <Tooltip title="Edit Cancelation Code">
                    <EditIcon sx={{ ml: 2, fontSize: "14px" }} />
                  </Tooltip>
                </Grid>
              )}
            </Grid>
          )}
        </>
      )}
      {showingTextField && (
        <TextField
          required
          fullWidth
          placeholder="Cancelation Code"
          onChange={(e) => handleCodeChange(e)}
          inputRef={(input) => input && input.focus()}
          value={cancelationCode}
          InputProps={{
            endAdornment: (
              <>
                <DoneIcon
                  sx={{ ml: 1, cursor: "pointer", fontSize: "14px" }}
                  onClick={() => {
                    if (cancelationCode !== "") {
                      handleCancelation(cancelationCode, rowParams.temp_id, rowParams.hotel_id);
                      toggleCancelOverlay("show");
                    }
                  }}
                />
                <ClearIcon
                  sx={{ ml: 1, fontSize: "14px", cursor: "pointer" }}
                  onClick={() => {
                    toggleCancelOverlay("hide");
                  }}
                />
              </>
            ),
          }}
        />
      )}
    </>
  );
}
